import React, {useMemo} from 'react'
import styles from './DevCardStats.module.scss'
import {useUIGameEndContext} from '../../../../../contexts/UIGameEndContext'
import {BarChart} from '../../BarChart'
import {CardDataController} from '@colonist/game-card-types'
import {UIGameCard} from '../../../../../common/UIGameCard'
import {T} from '../../../../../common/T'
import {CardEnum} from '@colonist/game-states'
import {useUIGameManagerContext} from '../../../../../contexts/UIGameManagerContext'

export const DevCardStats = () => {
    const gameManager = useUIGameManagerContext()
    const {gameEndData} = useUIGameEndContext()
    const activeDevelopmentCards = CardDataController.getCardEnumsOfTypes(gameManager.gameState.gameModeData.activeDevelopmentCardTypes)

    const resourceCardsCountMap = useMemo(() => {
        const countMap: {[key in CardEnum]?: number} = {}

        gameEndData.endGameState.developmentCardStats.forEach((num) => {
            if(countMap[num] === undefined) {
                countMap[num] = 0
            }
            countMap[num] += 1
        })

        return countMap
    }, [gameEndData])

    const chartData = useMemo(() => activeDevelopmentCards.map((cardId) => ({
        label: <UIGameCard
            cardId={cardId}
            className={styles.card}
            showTipTitle
        />,
        value: resourceCardsCountMap[cardId] ?? 0,
    })), [activeDevelopmentCards, resourceCardsCountMap])

    return (
        <div className={styles.container}>
            <div className={styles.title}>
                <T id={{key: 'strings:game.endGame.devCards.cardsDrawn', options: {
                    context: gameManager.gameState.gameModeData.translationKeyContext,
                }}} />
            </div>
            <BarChart chartData={chartData} />
        </div>
    )
}
